
(function () {
  let toastLock = false;

  function cleanProductTitle(rawTitle) {
    return (rawTitle || "")
      .replace(/\s*\(.*?\)\s*$/, "")     // убираем (варианты)
      .replace(/\s*-\s*[^-]+$/, "")      // убираем всё после тире
      .replace(/<strong>|<\/strong>/gi, "") // убираем <strong>
      .trim();
  }

  async function showDebutifyCartNotification(item) {
    try {
      if (toastLock) return;
      toastLock = true;
      setTimeout(() => (toastLock = false), 1000);

      // ждем инициализации Debutify (иногда widgets появляется позже)
      let tries = 0;
      while ((!window.Debutify || !Debutify.widgets) && tries < 10) {
        await new Promise(r => setTimeout(r, 100));
        tries++;
      }
      if (!window.Debutify || !Debutify.widgets) return;

      const widget = Debutify.widgets["cart-notification"];
      if (!widget || !widget.text) return;

      const notificationEl = document.querySelector("dbtfy-cart-notification");
      if (!notificationEl) return;

      const product = item?.items?.[0] || item;
      if (!product) return;

      const productTitle = cleanProductTitle(product.product_title || product.title);
      const imageUrl =
        product.image ||
        product.image_url ||
        product?.featured_image?.url ||
        null;

      // создаём временный HTML на основе шаблона блока
      const temp = notificationEl.cloneNode(true);
      const imgEl = temp.querySelector(".dbtfy-cart-notification__img");
      const textEl = temp.querySelector(".dbtfy-cart-notification__block--text .title");

      if (imgEl && imageUrl) imgEl.src = imageUrl;

      const replacedText = Debutify.replaceVariables(widget.text, {
        product_title: productTitle,
      });
      if (textEl) textEl.innerHTML = replacedText;

      // показываем toast
      new Debutify.toast(temp.innerHTML, {
        position: "bottom-center",
        duration: 3000,
        closeIcon: notificationEl.dataset.closeIcon,
        colorScheme: notificationEl.dataset.colorScheme,
        customColorScheme: notificationEl.dataset.customColorScheme,
        maxWidth: "100%",
      });
    } catch (err) {
      console.error("Debutify Cart Notification error:", err);
    }
  }

  // --- Shopify.onItemAdded ---
  if (typeof Shopify !== "undefined") {
    const prev = Shopify.onItemAdded;
    Shopify.onItemAdded = function (item) {
      try { if (typeof prev === "function") prev(item); } catch (e) {}
      showDebutifyCartNotification(item);
    };
  }

  // --- Перехват fetch('/cart/add') ---
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const req = args[0];
      const url = typeof req === "string" ? req : req?.url || "";
      const method = (args[1]?.method || req?.method || "GET").toUpperCase();
      if (method === "POST" && /\/cart\/add(\.js)?/.test(url) && res.ok) {
        let payload = null;
        try { payload = await res.clone().json(); } catch (_) {}
        const hasTitle = payload?.product_title || payload?.title || payload?.items?.[0]?.title;
        if (hasTitle) showDebutifyCartNotification(payload);
      }
    } catch (e) {}
    return res;
  };

  // --- Перехват XMLHttpRequest ---
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._atk = { method: method?.toUpperCase(), url: String(url || "") };
    return _open.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      this.addEventListener("load", function () {
        try {
          const ok = this.status >= 200 && this.status < 300;
          if (
            ok &&
            this._atk &&
            this._atk.method === "POST" &&
            /\/cart\/add(\.js)?/.test(this._atk.url)
          ) {
            let payload = null;
            try { payload = JSON.parse(this.responseText); } catch (_) {}
            const hasTitle = payload?.product_title || payload?.title || payload?.items?.[0]?.title;
            if (hasTitle) showDebutifyCartNotification(payload);
          }
        } catch (e) {}
      });
    } catch (e) {}
    return _send.call(this, body);
  };
})();

